import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import categoryReducer from "./slices/categorySlice";
import contactUsReducer from "./slices/contactSlice";
import dashboardReducer from "./slices/dashboardSlice";
import designationReducer from "./slices/designationSlice";
import enquireReducer from "./slices/enquireSlice";
import jobApplyReducer from "./slices/jobApplySlice";
import otherFieldSlice from "./slices/otherFieldSlice";
import projectReducer from "./slices/projectSlice";
import settingReducer from "./slices/settingSlice";

import testimonialReducer from "./slices/testimonialSlice";
import careerCategoryReducer from "./slices/careerCategorySlice";
import channelPartnerReducer from "./slices/channelPartnerSlice";
import aboutUsReducer from "./slices/aboutUsSlice";
import blogReducer from "./slices/blogSlice";
import complianceReducer from "./slices/complianceSlice";


const store = configureStore({
  reducer: {
    authReducer,
    dashboardReducer,
    categoryReducer,
    designationReducer,
    projectReducer,
    testimonialReducer,
    contactUsReducer,
    settingReducer,
    jobApplyReducer,
    otherFieldSlice,
    enquireReducer,
    careerCategoryReducer,
    channelPartnerReducer,
    aboutUsReducer,
    blogReducer,
    complianceReducer,
  },
});

export default store;
export type AppDispatch = typeof store.dispatch;
